"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useControlledState_1 = __importDefault(require("./useControlledState"));
var CREATE_VALUE = '__CREATE_OPTION_VALUE__';
function useCreatableSelectProps(_a) {
    var _this = this;
    var _b = _a.formatCreateLabel, formatCreateLabel = _b === void 0 ? function (inputText) { return "Create \"" + inputText + "\""; } : _b, _c = _a.position, position = _c === void 0 ? 'after' : _c, allowCreate = _a.allowCreate, _d = _a.isValidNewOption, isValidNewOption = _d === void 0 ? function () { return true; } : _d, inputValue = _a.inputValue, onInputChange = _a.onInputChange, args = __rest(_a, ["formatCreateLabel", "position", "allowCreate", "isValidNewOption", "inputValue", "onInputChange"]);
    var _e = useControlledState_1.default({
        value: inputValue,
        defaultValue: '',
    }), inputText = _e[0], setInputText = _e[1];
    var _f = react_1.useState(false), creating = _f[0], setCreating = _f[1];
    var createOptions = react_1.useMemo(function () {
        var _a;
        var addCreationOption = !((_a = args.options) === null || _a === void 0 ? void 0 : _a.some(function (option) { return option.label.toLowerCase() === inputText.toLowerCase(); })) || [];
        return inputText && allowCreate && isValidNewOption(inputText) && addCreationOption ? [
            {
                label: formatCreateLabel(inputText),
                value: CREATE_VALUE,
                isDisabled: creating,
            },
        ] : [];
    }, [inputText, creating, allowCreate, args.options]);
    var options = react_1.useMemo(function () { return position === 'before' ? __spreadArrays(createOptions, args.options) : __spreadArrays(args.options, createOptions); }, [createOptions, args.options, position]);
    var selectProps = args.multi ? {
        multi: true,
        value: args.value,
        onChange: function (multiVal) {
            if (multiVal === void 0) { multiVal = []; }
            return __awaiter(_this, void 0, void 0, function () {
                var idx, newOpt, newOptArr;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            idx = -1;
                            if (allowCreate) {
                                idx = multiVal.findIndex(function (opt) { return opt.value.split('::')[0] === CREATE_VALUE; });
                            }
                            if (!(idx !== -1)) return [3 /*break*/, 2];
                            setCreating(true);
                            return [4 /*yield*/, args.onCreateOption(inputText)];
                        case 1:
                            newOpt = _c.sent();
                            newOptArr = Array.isArray(newOpt) ? newOpt : [newOpt];
                            setCreating(false);
                            (_a = args.onChange) === null || _a === void 0 ? void 0 : _a.call(args, __spreadArrays(multiVal.slice(0, idx), newOptArr, multiVal.slice(idx + 1)));
                            return [3 /*break*/, 3];
                        case 2:
                            (_b = args.onChange) === null || _b === void 0 ? void 0 : _b.call(args, multiVal);
                            _c.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    } : {
        multi: false,
        value: args.value,
        onChange: function (singleVal) { return __awaiter(_this, void 0, void 0, function () {
            var newOpt;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(allowCreate && (singleVal === null || singleVal === void 0 ? void 0 : singleVal.value) === CREATE_VALUE)) return [3 /*break*/, 2];
                        setCreating(true);
                        return [4 /*yield*/, args.onCreateOption(inputText)];
                    case 1:
                        newOpt = _c.sent();
                        setCreating(false);
                        (_a = args.onChange) === null || _a === void 0 ? void 0 : _a.call(args, newOpt);
                        return [3 /*break*/, 3];
                    case 2:
                        (_b = args.onChange) === null || _b === void 0 ? void 0 : _b.call(args, singleVal);
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    };
    return __assign({ options: options, inputValue: inputText, onInputChange: function (text, meta) {
            onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(text, meta);
            setInputText(text);
        }, loading: creating }, selectProps);
}
exports.default = useCreatableSelectProps;
